import styled from "styled-components";

export const MathText = styled.div` 
    font-family: sans-serif;
    color: green;
    font-size: 14px;
    margin-bottom: 1%;
    text-align: center;
    @media screen and (max-width: 768px){
        font-size: 1em;
    }

`;


export const MathTitle = styled.div` 

    font-family: sans-serif;
    color: green;
    font-size: 24px;
    margin-bottom: 5%;
    @media screen and (max-width: 768px){
        font-size: 2em;
    }

`;


export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

`;




